import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home/Home.vue';
import Login from '../views/login/Login.vue';
import { AUTH_SERVICE } from '@/services/auth.service';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
];

const router = new VueRouter({
  routes
});

/**
 * Hook ejecutado ante cada cambio en la ruta
 *
 * Chequea que para los routes autenticados (requieren usuario existente) exista usuario logueado,
 * 	si no hay usuario logueado se redirige a login.
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.auth)) {
    AUTH_SERVICE.sesionActual()
      .then(() => next())
      .catch(() => next({ name: 'Login' }));
  }
  else {
    next();
  }
});

export default router;

